export default {"src":"/_next/static/media/2.621908b7.svg","height":170,"width":305,"blurWidth":0,"blurHeight":0};